import ProductEntity from "@modules/products/entities/ProductEntity";

import { ProductPriceSdkDto } from "../types";

export function mapProductPriceToSdkDto(
    price: ProductEntity["variants"][0]["price"]
): ProductPriceSdkDto {
    return {
        currency: price.currency,
        amount: price.amount,
    };
}
